import { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import { api } from "../lib/api";
import TextList from "../components/TextList";
import { accentForSubcategory } from "../lib/typeAccent";

const SUBCATEGORIES = {
  prosa: {
    label: "Prosa",
    subs: [
      { slug: "pensamientos", label: "Pensamientos" },
      { slug: "relatos", label: "Relatos" },
      { slug: "microrelatos", label: "Microrelatos" },
    ],
    intro:
      "La prosa es aquí el río lento: pensamientos al margen, relatos que se toman su tiempo y microrelatos que caben en el hueco de una mano.",
  },
  versos: {
    label: "Versos",
    subs: [{ slug: "poemas", label: "Poemas" }],
    intro:
      "El verso pide silencio. Aquí se recogen poemas escritos despacio, como quien enciende una vela en una habitación vacía.",
  },
};

const SUB_MAP = {
  pensamientos: "Pensamientos",
  relatos: "Relatos",
  microrelatos: "Microrelatos",
  poemas: "Poemas",
};

export default function Category({ main }) {
  const { sub } = useParams();
  const cfg = SUBCATEGORIES[main];
  const [texts, setTexts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const params = { main_category: cfg.label, limit: 200 };
        if (sub && SUB_MAP[sub]) params.subcategory = SUB_MAP[sub];
        const { data } = await api.get("/texts", { params });
        setTexts(data);
      } finally {
        setLoading(false);
      }
    })();
  }, [main, sub, cfg.label]);

  return (
    <div
      className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-32"
      data-testid={`category-page-${main}`}
    >
      <div
        className="text-xs uppercase tracking-[0.35em] mb-6"
        style={{ color: "var(--rincon-secondary)" }}
      >
        Categoría
      </div>
      <h1
        className="font-display text-6xl md:text-7xl tracking-tight"
        style={{ color: "var(--rincon-text)" }}
      >
        {cfg.label}
      </h1>
      <p
        className="font-body italic mt-6 max-w-2xl text-xl leading-relaxed"
        style={{ color: "var(--rincon-text-muted)" }}
      >
        {cfg.intro}
      </p>

      <div
        className="mt-14 mb-10 pb-6 border-b flex flex-wrap gap-x-8 gap-y-3"
        style={{ borderColor: "var(--rincon-border)" }}
      >
        <NavLink
          to={`/${main}`}
          end
          data-testid="subfilter-all"
          className={({ isActive }) =>
            `font-display text-lg ink-link ${isActive ? "font-semibold" : ""}`
          }
          style={({ isActive }) => ({
            color: isActive ? "var(--rincon-primary)" : "var(--rincon-text-muted)",
          })}
        >
          Todo
        </NavLink>
        {cfg.subs.map((s) => {
          const accent = accentForSubcategory(s.label);
          return (
            <NavLink
              key={s.slug}
              to={`/${main}/${s.slug}`}
              data-testid={`subfilter-${s.slug}`}
              className={({ isActive }) =>
                `font-display text-lg ink-link transition-colors ${isActive ? "font-bold" : ""}`
              }
              style={({ isActive }) => ({
                color: isActive ? accent : "var(--rincon-text-muted)",
                borderBottom: isActive ? `2px solid ${accent}` : "none",
                paddingBottom: isActive ? "2px" : "4px",
              })}
            >
              {s.label}
            </NavLink>
          );
        })}
      </div>

      {loading ? (
        <div
          className="py-24 text-center font-display italic text-2xl"
          style={{ color: "var(--rincon-text-muted)" }}
        >
          Cargando...
        </div>
      ) : (
        <TextList texts={texts} emptyMessage={`Aún no hay textos en ${cfg.label}.`} />
      )}
    </div>
  );
}
